import '../interfaceSettings.css';
import pic1 from '../assets/webp/drKaren.webp';
import pic2 from '../assets/webp/drWals.webp';
import pic3 from '../assets/webp/drCorey.webp';

const About = () => {
    return (
        <section id="about" className="container mt-5 mb-5">
            <div className="about-content lead mb-4" style={{ maxWidth: '800px', margin: '0 auto' }}>
            <h1>About Us</h1>
            <p className="about-intro">About Us
            Welcome to Grizzly Fitness at Your Fingertips.
            The origin of this software application is the result of a Georgia Gwinnett College (GGC) experiential 
            learning collaborative project in the Department of Exercise Science and the Department of Information 
            Technology. The application itself was created by software development undergraduate students while exercise 
            science clinical and health promotion students created the fitness video content. The content 
            presented in the application is based upon scientific evidence and principles supported by the 
            American College of Sports Medicine (ACSM). This project was supported, in part through GGC STEC 
            4500 research mini grant and a GGC Research SEED grant funds.
            </p>

            <hr className="my-4" />

            <h2 className="text-center mb-4">Clients</h2>

<div className="container" style={{ maxWidth: '800px' }}>
  {/* Karen */}
  <div className="row mb-4">
    <div className="col-12">
      <div className="p-3 border d-flex flex-wrap align-items-center">
        <div className="col-12 col-md-4 mb-3 mb-md-0">
          <img src={pic1} alt="Dr. Karen Lee Perell-Gerson in a floral top" className="img-fluid rounded client-img" />
        </div>
        <div className="col-12 col-md-8">
          <h3>Dr. Karen Lee Perell-Gerson</h3>
          <p className="client-bio mb-0">
            Dr. Perell-Gerson has served as a faculty member at the collegiate and graduate levels with appointments at UCLA and California State University, Fullerton. Her primary area of practice and research has been in kinesiotherapy and biomechanics, specifically, the movement patterns presented with chronic diseases. At Georgia Gwinnett College, she examines the benefits of an applied learning environment that allows the student to be part of the research process and be prepared for career development.
          </p>
        </div>
      </div>
    </div>
  </div>

  {/* Kristie */}
  <div className="row mb-4">
    <div className="col-12">
      <div className="p-3 border d-flex flex-wrap align-items-center">
        <div className="col-12 col-md-4 mb-3 mb-md-0">
          <img src={pic2} alt="Dr. Kristie Walsdorf in a black collared shirt" className="img-fluid rounded client-img" />
        </div>
        <div className="col-12 col-md-8">
          <h3>Dr. Kristie Walsdorf</h3>
          <p className="client-bio mb-0">
            Dr. Walsdorf graduated from Florida State University with a doctorate in physical education teacher education. While working on her Ph.D. she served as a full-time instructor in the Department of Kinesiology at Valdosta State University for four years. After leaving VSU, she was hired as an assistant professor of physical education teacher education at her alma mater, Florida State University. Walsdorf taught a variety of PETE undergraduate and graduate courses in addition to managing the student teaching internship program for seven years.
          </p>
        </div>
      </div>
    </div>
  </div>

  {/* Cindie */}
  <div className="row mb-4">
    <div className="col-12">
      <div className="p-3 border d-flex flex-wrap align-items-center">
        <div className="col-12 col-md-4 mb-3 mb-md-0">
          <img src={pic3} alt="Ms. Cindie A. Corey in a v-neck black top" className="img-fluid rounded client-img" />
        </div>
        <div className="col-12 col-md-8">
          <h3>Ms. Cindie A. Corey</h3>
          <p className="client-bio mb-0">
            Ms. Cindie Corey is an instructor in the exercise science and physical education disciplines.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<hr className="my-4" />

<section id="team" className="mt-5 mb-5">
  <div className="container" style={{ maxWidth: '800px' }}>
    <h2 className="text-center mb-4">Development Team</h2>

    <p className="about-intro">
      The GGC Walking Trails App was developed by Software Development interns and students at GGC under the supervision of the professors.
    </p>

    {/* Top row: Professors + Interns */}
    <div className="row mb-4">
      <div className="col-12 col-md-6 mb-3">
        <div className="p-3 border h-100">
          <h3>Professors</h3>
          <p className="mb-2">Dr. Anca Doloc-Mihu</p>
          <p className="mb-2">Dr. Cengiz Gunay</p>
        </div>
      </div>
      <div className="col-12 col-md-6 mb-3">
        <div className="p-3 border h-100">
          <h3>Interns</h3>
          <p className="mb-2">Joel Erulu</p>
          <p className="mb-2">Mathews Binny</p>
        </div>
      </div>
    </div>

{/* Bottom row: Students */}
<div className="row">
  <div className="col-12">
    <div className="p-3 border">
      <h3>Students</h3>
      <div className="row">
        <div className="col-12 col-md-6">
          <p className="mb-2">Wesley Chung</p>
          <p className="mb-2">Emree Jensen</p>
          <p className="mb-2">DQuavious Browner</p>
          <p className="mb-2">Jessica Dixon</p>
          <p className="mb-2">Josiah Haines</p>
        </div>
        <div className="col-12 col-md-6">
          <p className="mb-2">Fareed Ahmed</p>
          <p className="mb-2">Jacob Groover</p>
          <p className="mb-2">Alex Shaklee</p>
          <p className="mb-2">Samir Hernandez-Mendoza</p>
          <p className="mb-2">Ginette Wilson Bahun</p>
        </div>
      </div>
    </div>
  </div>
</div>
  </div>
</section>
            </div>



        </section>
    );
};

export default About;